import { useState } from 'react'
import type { Tasting } from '../../types'
import { generateExportText, copyToClipboard } from '../../utils/export'

type ExportButtonProps = {
  tasting: Tasting
}

export function ExportButton({ tasting }: ExportButtonProps) {
  const [showCopied, setShowCopied] = useState(false)

  const handleClick = async () => {
    const text = generateExportText(tasting)
    const success = await copyToClipboard(text)
    if (success) {
      setShowCopied(true)
      setTimeout(() => setShowCopied(false), 2000)
    }
  }

  return (
    <div className="relative inline-block">
      <button
        onClick={handleClick}
        className="px-4 py-2 bg-black text-cream rounded hover:bg-black/80 transition-colors"
      >
        Copy to Clipboard
      </button>
      {showCopied && (
        <div className="absolute left-1/2 -translate-x-1/2 -top-10 px-3 py-1 bg-black text-cream text-sm rounded shadow-lg whitespace-nowrap">
          Copied!
        </div>
      )}
    </div>
  )
}
